(() => {
  const page = document.querySelector(".pdp-v2-page--lullme");
  if (!page) return;

  const gallery = page.querySelector('[data-media-gallery][data-gallery-variant="lullme"]');
  const mainImage = gallery?.querySelector("[data-lullme-main-image]");
  const galleryTabs = gallery ? Array.from(gallery.querySelectorAll('[role="tab"]')) : [];

  const selectGalleryTab = (selectedTab) => {
    galleryTabs.forEach((tab) => {
      const selected = tab === selectedTab;
      tab.classList.toggle("is-selected", selected);
      tab.setAttribute("aria-selected", String(selected));
      if (selected) tab.setAttribute("aria-current", "true");
      else tab.removeAttribute("aria-current");
      tab.tabIndex = selected ? 0 : -1;
    });
  };

  galleryTabs.forEach((tab, index) => {
    const selected = index === 0;
    tab.classList.toggle("is-selected", selected);
    tab.setAttribute("aria-selected", String(selected));
    if (selected) tab.setAttribute("aria-current", "true");
    else tab.removeAttribute("aria-current");
    tab.tabIndex = selected ? 0 : -1;
  });

  galleryTabs.forEach((button) => {
    button.addEventListener("click", () => {
      const source = button.querySelector("img");
      if (!source || !mainImage) return;
      const mainSrcset = source.dataset.mainSrcset || source.getAttribute("srcset");
      const mainSizes = source.dataset.mainSizes || source.getAttribute("sizes");
      if (mainSrcset) mainImage.setAttribute("srcset", mainSrcset);
      else mainImage.removeAttribute("srcset");
      if (mainSizes) mainImage.setAttribute("sizes", mainSizes);
      else mainImage.removeAttribute("sizes");
    });
  });

  page.querySelectorAll("[data-lullme-color-image]").forEach((button) => {
    button.addEventListener("click", () => {
      if (!mainImage) return;
      mainImage.src = button.dataset.lullmeColorImage;
      mainImage.srcset = button.dataset.lullmeColorSrcset || "";
      mainImage.sizes = "(max-width: 720px) calc(100vw - 32px), 576px";
      mainImage.alt = button.dataset.lullmeColorAlt || "LULLME";
      const firstTab = galleryTabs[0];
      const firstImage = firstTab?.querySelector("img");
      if (firstImage) {
        firstImage.src = button.dataset.lullmeColorImage;
        firstImage.srcset = button.dataset.lullmeColorSrcset || "";
        firstImage.alt = "";
      }
      if (firstTab) selectGalleryTab(firstTab);
    });
  });

  const quantity = page.querySelector("#lullme-quantity")
    || page.querySelector('.lullme-v2-quantity-control input[name="quantity"]');
  const updateQuantity = (delta) => {
    if (!quantity) return;
    const min = Number(quantity.min) || 1;
    quantity.value = String(Math.max(min, (Number(quantity.value) || min) + delta));
    quantity.dispatchEvent(new Event("input", { bubbles: true }));
    quantity.dispatchEvent(new Event("change", { bubbles: true }));
  };
  const quantityMinus = page.querySelector("[data-quantity-minus]")
    || page.querySelector('.lullme-v2-quantity-control button[name="minus"]');
  const quantityPlus = page.querySelector("[data-quantity-plus]")
    || page.querySelector('.lullme-v2-quantity-control button[name="plus"]');
  quantityMinus?.addEventListener("click", () => updateQuantity(-1));
  quantityPlus?.addEventListener("click", () => updateQuantity(1));

  const cartStatus = page.querySelector("[data-cart-status]");
  page.querySelectorAll("[data-static-cart]").forEach((button) => {
    button.addEventListener("click", () => {
      const color = page.querySelector('[data-product-option="Color"] [data-selected-option]')?.textContent?.trim() || "選択中カラー";
      const count = Number(quantity?.value) || 1;
      if (cartStatus) cartStatus.textContent = `${color}・数量${count}を選択中です。Shopifyネイティブカート接続前の静的確認です。`;
      const original = button.dataset.originalLabel || button.textContent.trim();
      button.dataset.originalLabel = original;
      button.textContent = "選択内容を確認しました";
      button.classList.add("is-added");
      window.setTimeout(() => {
        button.textContent = original;
        button.classList.remove("is-added");
      }, 1600);
    });
  });

  const coupon = page.querySelector(".lullme-v2-coupon-card");
  coupon?.querySelector("[data-coupon-copy]")?.addEventListener("click", async () => {
    const code = coupon.dataset.couponCode?.trim();
    const status = coupon.querySelector("[data-coupon-status]");
    if (!code) {
      if (status) status.textContent = "情報確認依頼: 5%OFFクーポンの正式コードと利用条件";
      return;
    }
    try {
      await navigator.clipboard.writeText(code);
      if (status) status.textContent = `クーポンコード ${code} をコピーしました。`;
    } catch {
      if (status) status.textContent = `クーポンコードは ${code} です。`;
    }
  });

  const reviews = page.querySelector(".lullme-v2-reviews");
  const reviewItems = reviews ? Array.from(reviews.querySelectorAll(".lullme-v2-reviews__grid article")) : [];
  if (reviews && reviewItems.length > 2) {
    const more = document.createElement("button");
    more.type = "button";
    more.className = "lullme-v2-reviews__more";
    more.textContent = "さらに読み込む";
    more.addEventListener("click", () => {
      reviewItems.slice(2).forEach((item) => item.classList.add("is-revealed"));
      more.hidden = true;
    });
    reviews.querySelector(".lullme-v2-reviews__note")?.before(more);
  }

  page.querySelectorAll('a[href="#voices"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      page.querySelector(".lullme-v2-voices")?.scrollIntoView({ behavior: reduced ? "auto" : "smooth" });
    });
  });

  const faqHeader = page.querySelector(".lullme-v2-faq-section header");
  if (faqHeader) {
    faqHeader.querySelector("h2").textContent = "よくあるご質問";
    faqHeader.querySelector("p").textContent = "FAQ";
  }
  const relatedHeader = page.querySelector(".lullme-v2-related-section header");
  if (relatedHeader) {
    relatedHeader.querySelector("h2").textContent = "おすすめの関連商品";
    relatedHeader.querySelector("p").textContent = "RELATED";
  }
})();
